import React from 'react';
import { Link } from 'react-router-dom';
import { ShoppingCart, Menu, X } from 'lucide-react';
import { useCart } from '../contexts/CartContext';
import { Button } from './ui/button';

const Navbar = () => {
  const { getCartCount } = useCart();
  const [mobileMenuOpen, setMobileMenuOpen] = React.useState(false);

  return (
    <nav className="sticky top-0 z-50 bg-warm-paper/90 backdrop-blur-md border-b border-alt-bg">
      <div className="max-w-7xl mx-auto px-6">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <Link to="/" className="flex items-center space-x-2" data-testid="nav-logo">
            <img 
              src="https://customer-assets.emergentagent.com/job_88eff453-8cb5-48a1-90c9-5da44516acba/artifacts/0vpwarrb_Jelly%20Logo%20JPG.JPG" 
              alt="Preserves of Cape Cod Logo" 
              className="h-14 w-auto object-contain"
            />
          </Link>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center space-x-8">
            <Link
              to="/shop"
              className="text-sm font-semibold uppercase tracking-wider text-[#2D2A26] hover:text-cape-red transition-colors"
              data-testid="nav-shop"
            >
              Shop All
            </Link>
            <Link
              to="/about"
              className="text-sm font-semibold uppercase tracking-wider text-[#2D2A26] hover:text-cape-red transition-colors"
              data-testid="nav-about"
            >
              About
            </Link>
            <Link
              to="/contact"
              className="text-sm font-semibold uppercase tracking-wider text-[#2D2A26] hover:text-cape-red transition-colors"
              data-testid="nav-contact"
            >
              Contact
            </Link>
            <Link to="/cart" className="relative" data-testid="nav-cart">
              <ShoppingCart className="w-6 h-6 text-[#2D2A26] hover:text-cape-red transition-colors" />
              {getCartCount() > 0 && (
                <span className="cart-badge" data-testid="cart-count">
                  {getCartCount()}
                </span>
              )}
            </Link>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            className="md:hidden"
            data-testid="mobile-menu-button"
          >
            {mobileMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>

        {/* Mobile Menu */}
        {mobileMenuOpen && (
          <div className="md:hidden py-4 border-t border-alt-bg" data-testid="mobile-menu">
            <div className="flex flex-col space-y-4">
              <Link
                to="/shop"
                className="text-sm font-semibold uppercase tracking-wider text-[#2D2A26] hover:text-cape-red"
                onClick={() => setMobileMenuOpen(false)}
              >
                Shop All
              </Link>
              <Link
                to="/about"
                className="text-sm font-semibold uppercase tracking-wider text-[#2D2A26] hover:text-cape-red"
                onClick={() => setMobileMenuOpen(false)}
              >
                About
              </Link>
              <Link
                to="/contact"
                className="text-sm font-semibold uppercase tracking-wider text-[#2D2A26] hover:text-cape-red"
                onClick={() => setMobileMenuOpen(false)}
              >
                Contact
              </Link>
              <Link
                to="/cart"
                className="flex items-center space-x-2"
                onClick={() => setMobileMenuOpen(false)}
              >
                <ShoppingCart className="w-5 h-5" />
                <span>Cart ({getCartCount()})</span>
              </Link>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
};

export default Navbar;
